function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createUserActivity, saveSubmitSurveyResponded } from 'rubriq/actions';
import hasRespondedToSubmitSurvey from 'rubriq/helpers/submitSurveyResponded';
import { RUBRIQ_FEATURE_SURVEY_DELAY_MS, RUBRIQ_SUBMIT_SURVEY_ZONKA_FORM_ID, RUBRIQ_SUBMIT_SURVEY_ZONKA_NONPROD_FORM_ID, CURRENT_SUBMIT_SURVEY_VERSION } from 'rubriq/constants';
import { getChinaLocalization } from 'shared/account/reducer';
import featureEnabled from 'shared/helper/feature';
import { loadZonkaScript, triggerZonkaSurvey } from './zonkaFeedbackClient';
var useSubmitSurveyTrigger = function useSubmitSurveyTrigger(feature, trigger) {
  var dispatch = useDispatch();
  var isChinaUser = useSelector(getChinaLocalization);
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    _useSelector$user = _useSelector.user,
    userIdentity = _useSelector$user.identity,
    userEmail = _useSelector$user.email,
    firstName = _useSelector$user.firstName,
    lastName = _useSelector$user.lastName;
  var plan = useSelector(function (state) {
    var _state$curie;
    return (_state$curie = state.curie) === null || _state$curie === void 0 ? void 0 : _state$curie.plan;
  });
  var planRef = useRef(plan);
  planRef.current = plan;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    scriptReady = _useState2[0],
    setScriptReady = _useState2[1];
  var surveyActiveRef = useRef(false);
  var surveyWasVisibleRef = useRef(false);
  var surveySubmittedRef = useRef(false);
  var handleSurveyFinished = useCallback(function () {
    if (!surveyActiveRef.current) return;
    surveyActiveRef.current = false;
    surveyWasVisibleRef.current = false;
    if (surveySubmittedRef.current) {
      surveySubmittedRef.current = false;
      dispatch(saveSubmitSurveyResponded({
        feature: feature,
        version: CURRENT_SUBMIT_SURVEY_VERSION
      }));
    }
  }, [dispatch, feature]);
  useEffect(function () {
    loadZonkaScript().then(function () {
      return setScriptReady(true);
    });
  }, []);
  useEffect(function () {
    var findZonkaContainer = function findZonkaContainer() {
      return document.querySelector('[id*="zf-"], [class*="zf-"], iframe[src*="zonka"]');
    };
    var observer = new MutationObserver(function () {
      if (!surveyActiveRef.current) return;
      var zfContainer = findZonkaContainer();
      if (zfContainer) {
        surveyWasVisibleRef.current = true;
        if (zfContainer.style.display === 'none') {
          handleSurveyFinished();
        }
        return;
      }
      if (surveyWasVisibleRef.current) {
        handleSurveyFinished();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
    var handlePostMessage = function handlePostMessage(event) {
      var _event$origin;
      if (!((_event$origin = event.origin) !== null && _event$origin !== void 0 && _event$origin.includes('zonka'))) return;
      var data = event.data;
      if (data === 'surveyform.loaded') return;
      var message = typeof data === 'string' ? data.toLowerCase() : '';
      var isSubmitEvent = message === 'zf-embed-submit-close' || message === 'zf-embed-submit-only' || _typeof(data) === 'object' && data !== null && data.action === 'surveySubmitted';
      if (isSubmitEvent) {
        surveySubmittedRef.current = true;
      }
      var isCloseEvent = isSubmitEvent || message.includes('formclosed') || message.includes('surveyclosed') || message.includes('survey-closed') || _typeof(data) === 'object' && data !== null && (data.event === 'formClosed' || data.event === 'surveyClosed');
      if (isCloseEvent) {
        handleSurveyFinished();
      }
    };
    window.addEventListener('message', handlePostMessage);
    return function () {
      observer.disconnect();
      window.removeEventListener('message', handlePostMessage);
    };
  }, [handleSurveyFinished]);
  useEffect(function () {
    if (!trigger || !scriptReady || !featureEnabled('zonka_survey')) {
      return undefined;
    }
    if (hasRespondedToSubmitSurvey(planRef.current)) {
      return undefined;
    }
    if (surveyActiveRef.current) {
      return undefined;
    }
    surveyActiveRef.current = true;
    surveyWasVisibleRef.current = false;
    surveySubmittedRef.current = false;
    var contactName = [firstName, lastName].filter(Boolean).join(' ');
    var variables = {
      user_identity: userIdentity,
      origin: 'aje',
      feature: feature
    };
    if (contactName) {
      variables.contact_name = contactName;
    }
    if (userEmail) {
      variables.contact_email = userEmail;
    }
    var timer = setTimeout(function () {
      dispatch(createUserActivity({
        feature: feature,
        activity: 'inapp_submit_survey_sent'
      }));
      triggerZonkaSurvey({
        language: isChinaUser ? 'zh_TW' : 'en_US',
        variables: variables,
        formId: RUBRIQ_SUBMIT_SURVEY_ZONKA_FORM_ID,
        nonProdFormId: RUBRIQ_SUBMIT_SURVEY_ZONKA_NONPROD_FORM_ID
      });
    }, RUBRIQ_FEATURE_SURVEY_DELAY_MS);
    return function () {
      return clearTimeout(timer);
    };
  }, [trigger, feature, dispatch, isChinaUser, userIdentity, userEmail, firstName, lastName, scriptReady]);
};
export default useSubmitSurveyTrigger;